import { getJWT } from "@utils/browser-helpers";
import type { GoogleAnalyticsContent } from "@types";

export const googleAnalyticsEventSelection = (
  typeOfEvent: string,
  content: GoogleAnalyticsContent
): void => {
  const JWT_DECODED = getJWT();
  setCustomDimensionsAndMetricsConfig();
  
  if (typeof gtag !== "undefined") {
    gtag("event", `${typeOfEvent} Content ${content.category}`, {
      event_category: content.category,
      event_label: JSON.stringify(content.payload),
      id: content.id,
      username: JWT_DECODED.username.toLowerCase(),
      clienttypeid: JWT_DECODED.ctid,
    });
  }
};

const setCustomDimensionsAndMetricsConfig = (): void => {
  if (typeof gtag !== "undefined") {
    gtag("config", "UA-124938110-6", {
      custom_map: {
        page_title: document.title,
        dimension1: "id",
        dimension2: "username",
        dimension3: "clienttypeid",
      },
    });
  }
};
